import React from "react";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.jsx";

function AssetTreeNode({ node, selectedAssetId, onSelect, depth }) {
  const isSelected = selectedAssetId === node.id;

  return (
    <div>
      <div style={{ marginLeft: depth * 14, marginBottom: 4 }}>
        <Button
          size="sm"
          color={isSelected ? "info" : "white"}
          onClick={() => onSelect(node.id)}
        >
          {node.name}
        </Button>
      </div>
      {(node.children || []).map(child => (
        <AssetTreeNode
          key={child.id}
          node={child}
          selectedAssetId={selectedAssetId}
          onSelect={onSelect}
          depth={depth + 1}
        />
      ))}
    </div>
  );
}

AssetTreeNode.propTypes = {
  node: PropTypes.object.isRequired,
  selectedAssetId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  depth: PropTypes.number.isRequired
};

export default function AssetTree({ tree, selectedAssetId, onSelect }) {
  if (!tree || tree.length === 0) {
    return <div>No assets available.</div>;
  }

  return (
    <div>
      {tree.map(root => (
        <AssetTreeNode
          key={root.id}
          node={root}
          selectedAssetId={selectedAssetId}
          onSelect={onSelect}
          depth={0}
        />
      ))}
    </div>
  );
}

AssetTree.propTypes = {
  tree: PropTypes.array,
  selectedAssetId: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};
